
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const SpiritualJourneySection = () => {
  return (
    <section className="py-20 bg-white text-[#403E43] relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <circle cx="3" cy="3" r="1.5" fill="#D4AF37" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#dots)" />
        </svg>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-heaven-gold mb-6">
            Begin Your Spiritual Journey Today
          </h2>
          
          <p className="text-[#403E43]/80 text-lg mb-10">
            Let Biblical wisdom guide your modern path. Join our community of seekers finding divine
            guidance through Scripture.
          </p>
          
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/sign-up">
              <Button 
                variant="blue" 
                className="text-white hover:bg-heaven-gold hover:text-white border-2 border-[#34495E]"
                size="lg"
              >
                Sign Up Now
              </Button>
            </Link>
            
            <Link to="/bible-tools">
              <Button 
                variant="outline" 
                className="border-2 border-heaven-gold text-heaven-gold hover:bg-heaven-gold/10 hover:border-selah-navy"
                size="lg"
              >
                Learn More
              </Button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SpiritualJourneySection;
